module.exports = __webpack_public_path__ + "img/nothing.cb2ec07c.png";